export default __webpack_public_path__ + "static/media/swiftstrikes10.e4c41a74.png";